import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import ru from './ru.json';
import az from './az.json';
import pt from './pt.json'; // renamed br
import id from './id.json';
import hi from './hi.json';
import uk from './uk.json'; // renamed ua
import kk from './kk.json'; // renamed kz
import es from './es.json';
import mx from './mx.json';
import tr from './tr.json';
import uz from './uz.json';
import bn from './bn.json';
import vn from './vn.json';
import sp from './sp.json';
import zh from './zh.json';
import rs from './rs.json';
import de from './de.json';
import ar from './ar.json';
import bg from './bg.json';
import hu from './hu.json';
import bs from './bs.json';

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        lng: 'en',
        fallbackLng: [
            'en',
            'ru',
            'hi',
            'az',
            'br',
            'pt',
            'id',
            'ua',
            'uk',
            'kk',
            'kz',
            'es',
            'mx',
            'ch',
            'pe',
            'ec',
            'co',
            'tr',
            'uz',
            'bn',
            'bd',
            'vi',
            'vn',
            'sp',
            'zh',
            'rs',
            'de',
            'ar',
            'bg',
            'hu',
            'bs',
        ],
        debug: process.env.NODE_ENV !== 'production',
        resources: {
            en: {
                translation: en,
            },
            ru: {
                translation: ru,
            },
            az: {
                translation: az,
            },
            br: {
                translation: pt,
            },
            pt: {
                translation: pt,
            },
            id: {
                translation: id,
            },
            hi: {
                translation: hi,
            },
            ua: {
                translation: uk,
            },
            uk: {
                translation: uk,
            },
            kz: {
                translation: kk,
            },
            kk: {
                translation: kk,
            },
            es: {
                translation: es,
            },
            mx: {
                translation: mx,
            },
            ch: {
                translation: mx,
            },
            pe: {
                translation: mx,
            },
            ec: {
                translation: mx,
            },
            co: {
                translation: mx,
            },
            tr: {
                translation: tr,
            },
            uz: {
                translation: uz,
            },
            bn: {
                translation: bn,
              },
            bd: {
                translation: bn,
            },
            vi: {
                translation: vn,
              },
            vn: {
                translation: vn,
            },
            sp: {
                translation: sp,
            },
            zh: {
                translation: zh,
            },
            rs: {
                translation: rs,
            },
            de: {
                translation: de,
            },
            ar: {
                translation: ar,
            },
            bg: {
                translation: bg,
            },
            hu: {
                translation: hu,
            },
            bs: {
                translation: bs,
            },
        },
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
